export default __webpack_public_path__ + "static/media/support-seldon.c43eb49f.yaml";